import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

export const getAccountsCubeData = async () => {
    try {
        let url = `${BaseUrl}_1099_Contract_Accounting/get-accountsCube-data`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.result.statusCode === 200) {
            const sample = JSON.parse(res.data.result.payload)
            const loopedList = []
            sample.forEach(element => {
                var prj_strt = "";
                if (element.Project_Start !== "") {
                    if (element.Project_Start !== undefined) {
                        // const dateString = element.Project_Start;
                        // const dateObject = new Date(dateString);
                        // prj_strt = dateObject.toLocaleDateString("en-US");
                        const datestr = element.Project_Start;
                        const dateString = datestr.includes(" ") ? datestr.split(" ")[0] : datestr;
                        const [monthS, dayS, yearS] = dateString.split("/");
                        const dateObject = new Date(`${yearS}-${monthS}-${dayS}`);
                        const day = String(dateObject.getDate()).padStart(2, '0');
                        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                        const year = String(dateObject.getFullYear()); // Get last two digits of the year
                        // console.log(day, month, year)
                        prj_strt = `${month}/${day}/${year}`;
                        // console.log(prj_strt)
                    }
                }
                var prj_end = "";
                if (element.Project_End !== "") {
                    if (element.Project_Start !== undefined) {
                        // const dateString_end = element.Project_End;
                        // const dateObject_end = new Date(dateString_end);
                        // prj_end = dateObject_end.toLocaleDateString("en-US");
                        const dateStr_end = element.Project_End;
                        const dateString_end = dateStr_end.includes(" ") ? dateStr_end.split(" ")[0] : dateStr_end;
                        const [months, days, years] = dateString_end.split("/");
                        const dateObject_end = new Date(`${years}-${months}-${days}`);
                        // const dateObject_end = new Date(dateString_end);
                        const day = String(dateObject_end.getDate()).padStart(2, '0');
                        const month = String(dateObject_end.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                        // const year = String(dateObject_end.getFullYear()).slice(-2); // Get last two digits of the year
                        const year = String(dateObject_end.getFullYear());
                        prj_end = `${month}/${day}/${year}`;
                    }
                }

                loopedList.push({
                    "Id": element.Id,
                    "Entity": element.Entity,
                    "Contract_Vendor_Name": element.Contract_Vendor_Name,
                    "Vendor_Code": element.Vendor_Code,
                    "Portal": element.Portal,
                    "Customer": element.Customer,
                    "Department": element.Department,
                    "CostCenter": element.CostCenter,
                    "BusinessUnit": element.BusinessUnit,
                    "Location": element.Location,
                    "Main_Account": element.Main_Account,
                    "Net": element.Net,
                    "Pay_rate": element.Pay_rate,
                    "OT_Payrate": element.OT_Payrate,
                    "Method_of_Payment": element.Method_of_Payment,
                    "Timesheet_Name": element.Timesheet_Name,
                    "Currency": element.Currency,
                    "Ledger_Code": element.Ledger_Code,
                    "ValueStream": element.ValueStream,
                    "Worker_code": element.Worker_code,
                    "First_Name": element.First_Name,
                    "Middle_Name": element.Middle_Name,
                    "Last_Name": element.Last_Name,
                    "Project": element.Project,
                    // "Project_Start": element.Project_Start,
                    "Project_Start": prj_strt,
                    // "Project_End": element.Project_End,
                    "Project_End": prj_end,
                })
            });
            return loopedList;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
// get-payroll-data
export const getPayrollData = async (monthYear = '') => {
    try {
        let url = `${BaseUrl}_1099_Contract_Accounting/get-payrollHrs-latest-data`;
        
        if (monthYear) {
            url += `?MonthYear=${monthYear}`;
        }

        console.log("Fetching data from:", url);
        const res = await axios.get(url, JsonConfig);
        console.log("API Response:", res);

        if (res.data.statusCode === 200) {
          
            const sample = JSON.parse(res.data.payload);

            // Extract unique weekend dates and sort them in ascending order
            const uniqueDates = [...new Set(sample.map(item => item.Weekend))]
                .sort((a, b) => new Date(a) - new Date(b)); // Sort based on actual date order

            const uniqueDateList = uniqueDates.map(Weekend => ({ Weekend }));

            let loopedList = [];
            let wcSet = [];

            sample.forEach(element => {
                if (!wcSet.includes(element.WorkerCode)) {
                    const data = sample.filter(item => item.WorkerCode === element.WorkerCode);
                    wcSet.push(element.WorkerCode);

                    const sampleData = { ...element };

                    let weekends = {};
                    uniqueDateList.forEach(item => {
                        const date = item.Weekend;
                        const weekData = data.find(weeks => weeks.Weekend === date);
                        weekends[date] = weekData || {}; // Use backend data directly
                    });

                    loopedList.push({ ...sampleData, weekends });
                }
            });

            return [loopedList, uniqueDateList];
        } else {
            console.error("API Error:", res.data);
            ErrorMessage("Cannot able to get data");
            return null;
        }
    } catch (error) {
        console.error("Error fetching payroll data:", error);
        ErrorMessage("Cannot able to get data");
        return null;
    }
};



export const downloadMontlyData = async (monthYear) => {
    try {
        let url = `${BaseUrl}_1099_Contract_Accounting/get-payroll-dump-data?MonthYear=${monthYear}`;
        const res = await axios.get(url, JsonConfig);

        if (res.data.statusCode === 200) {
            const resp = await getPayrollData(monthYear)
            return resp
        }
        else if (res.data.statusCode === 500) {
            ErrorMessage("No records found in this month");
            return null;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const refreshPayrollData = async () => {
    try {
        let url = `${BaseUrl}_1099_Contract_Accounting/get-payroll-dump-data`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.statusCode === 200) {
            const resp = await getPayrollData();
            SuccessMessage(res.data.message)
            return resp;
        }
        if (res.data.statusCode === 500) {
            InfoMessage(res.data.message)
            return null;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const downloadVIJAX = async (monthYear, selectedValidatedRows,clearSelectedRows) => {
    try {
        const JsonConfig = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            }
        };

        const processedRows = selectedValidatedRows.map(item => ({
            ...item,
            Weekend: item.Weekend ? new Date(item.Weekend).toISOString() : null,
            WeekStartDate: item.WeekStartDate ? new Date(item.WeekStartDate).toISOString() : null,
            WorkTimeEntry_date: item.WorkTimeEntry_date ? new Date(item.WorkTimeEntry_date).toISOString() : null,
            DownloadDate: item.DownloadDate ? new Date(item.DownloadDate).toISOString() : null
        }));

        const url = `${BaseUrl}_1099_Contract_Accounting/get-VIJAX-template-data?MonthYear=${monthYear}`;

        const res = await axios.post(url, processedRows, JsonConfig);
        if (res.status === 200 && res.data.statusCode === 200 && res.data.payload) {
            const parsedPayload = JSON.parse(res.data.payload);
             // ✅ Clear selected rows
             if (typeof clearSelectedRows === "function") {
                clearSelectedRows();
            }
            return parsedPayload;
        } else {
            console.error("Unexpected response format:", res.data);
            ErrorMessage("Unable to get data");
            return null;
        }
        
        
        
    } catch (error) {
        console.error("Download error:", error);
        ErrorMessage("Error occurred while downloading");
        return null;
    }
};
export const downloadOTPOTemplate = async (monthYear, selectedValidatedRows,clearSelectedRows) => {
    try {
        const JsonConfig = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            }
        };

        const processedRows = selectedValidatedRows.map(item => ({
            ...item,
            Weekend: item.Weekend ? new Date(item.Weekend).toISOString() : null,
            WeekStartDate: item.WeekStartDate ? new Date(item.WeekStartDate).toISOString() : null,
            WorkTimeEntry_date: item.WorkTimeEntry_date ? new Date(item.WorkTimeEntry_date).toISOString() : null,
            DownloadDate: item.DownloadDate ? new Date(item.DownloadDate).toISOString() : null
        }));

        const url = `${BaseUrl}_1099_Contract_Accounting/OTPOTemplate?MonthYear=${monthYear}`;

        const res = await axios.post(url,processedRows, JsonConfig);
        if (res.status === 200 && res.data.statusCode === 200 && res.data.payload) {
            const parsedPayload = JSON.parse(res.data.payload);
             // ✅ Clear selected rows
             if (typeof clearSelectedRows === "function") {
                clearSelectedRows();
            }
            return parsedPayload;
        } 
        else if(res.data.statusCode === 204  ){
            InfoMessage("There is no OT Hours");
            return null;
        }
        else {
            console.error("Unexpected response format:", res.data);
            ErrorMessage("Unable to get data");
            return null;
        }
        
        
        
    } catch (error) {
        console.error("Download error:", error);
        ErrorMessage("Error occurred while downloading");
        return null;
    }
};


export const downloadAccruals = async () => {
    try {
        let url = `${BaseUrl}_1099_Contract_Accounting/get-accurals-template-data`;
        const res = await axios.get(url, JsonConfig)
        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload)
            return sample;
        }
        else {
            ErrorMessage("Cannot able to get data");
            return null;
        }
    }
    catch {
        ErrorMessage("Cannot able to get data");
        return null;
    }
}
export const downloadMSXL = async (val, props, ws,selectedValidatedRows=[],clearSelectedRows) => {
    try {
        const temp = props;
        const value = val;
        const weeks = ws;
        function getExcelColumnName(colNumber) {
            let columnName = '';
            while (colNumber > 0) {
                let remainder = (colNumber - 1) % 26;
                columnName = String.fromCharCode(65 + remainder) + columnName;
                colNumber = Math.floor((colNumber - 1) / 26);
            }
            return columnName;
        }
        function sanitizeCellValue(value) {
            if (typeof value === 'string' && /^[=+\-@]/.test(value.trim())) {
                return `'${value}`;
            }
            return value;
        }
        let selectedWeekend = weeks[1]?.Weekend;
        let selectedMonthYear = '';
        if (selectedWeekend) {
            const dateParts = selectedWeekend.split('/');
            if (dateParts.length === 3) {
                const month = dateParts[0].padStart(2, '0');
                const year = dateParts[2];
                selectedMonthYear = `${month}/${year}`; // Format: MM-YYYY
            }
        }

        const weekendValues = weeks.map(week => `WE ${week.Weekend}`);
        const wsValues = weeks.map(week => week.Weekend);
        const weekendValuesWithEmpty = weekendValues.reduce((acc, curr) => {
            acc.push(curr, "", "",""); // Push current value and empty string
            return acc;
        }, []);
        const RTDTOT = weekendValues.reduce((acc, curr) => {
            acc.push("RT", "OT", "DT","Status"); // Push current value and empty string
            return acc;
        }, []);
        if (temp.length > 0) {
            if (value === 'one') {
                let sampleList = temp;
                // console.log(sampleList)
                let loopedList = [];
                loopedList.length = 0;
                let len = sampleList.length;
                let i;
                let hoursData = []
                for (i = 0; i < len; i++) {
                    const weekendValuesList = [];
                    wsValues.forEach(date => {
                        const weekendData = sampleList[i].weekends[date];
                        const { RT = '0', OT = '0', DT = '0', Status = ''} = weekendData || {};
                        weekendValuesList.push(
                            sanitizeCellValue(RT),
                            sanitizeCellValue(OT),
                            sanitizeCellValue(DT),
                            sanitizeCellValue(Status)
                        );
                    });
                    loopedList.push([
                        sanitizeCellValue(sampleList[i].Client_Type),
                        sanitizeCellValue(sampleList[i].Client),
                        sanitizeCellValue(sampleList[i].Payroll_Name),
                        sanitizeCellValue(sampleList[i].Status),
                        ...weekendValuesList,
                        // sampleList[i].Other_Hours,
                        sanitizeCellValue(sampleList[i].RT_Total_Hours),
                        sanitizeCellValue(sampleList[i].OT_Total_Hours),
                        sanitizeCellValue(sampleList[i].Worked_Hours),
                        sanitizeCellValue(sampleList[i].Pay_rate),
                        sanitizeCellValue(sampleList[i].OT_Pay_rate),
                        sanitizeCellValue(sampleList[i].RT_Amount),
                        sanitizeCellValue(sampleList[i].OT_Amount),
                        sanitizeCellValue(sampleList[i].Invoice_Amount),
                        sanitizeCellValue(sampleList[i].Hourlyrate),
                        sanitizeCellValue(sampleList[i].Hourly_OT_Pay_rate),
                        sanitizeCellValue(sampleList[i].Invoice_Number),
                        sanitizeCellValue(sampleList[i].Invoice_Hrs),
                        sanitizeCellValue(sampleList[i].HourlyRate_Amount),
                        sanitizeCellValue(sampleList[i].Invoice_Date),
                        sanitizeCellValue(sampleList[i].Due_Date),
                        sanitizeCellValue(sampleList[i].Text),
                        sanitizeCellValue(sampleList[i].IsValidated),
                        // sampleList[i].DownloadDate
                    ])
                }
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
                const weekendColumnsCount = weekendValuesWithEmpty.length; // Calculate the total weekend columns
                const startWeekendColumn = 5; // Column E is the 5th column (A=1, B=2, ..., E=5)
                const endWeekendColumn = startWeekendColumn + weekendColumnsCount - 1;
                worksheet.getRow(1).values = ['Portal', 'Client', 'Payroll Name', 'Status',
                    ...weekendValuesWithEmpty, 'RT Total Hours', 'OT Total Hours', 'Total Hours', 'Regular Pay rate', 'OT Pay rate',
                    'RT Amount', 'OT Amount', 'Total Amount', 'Regular Hourly Rate', 'OT Hourly Rate',
                    'Invoice Number', 'Invoice Hours', 'Invoice Amount',
                    'Document Date', 'Due Date', 'Text', 'Is Validated']
                worksheet.getRow(2).values = ['', '', '', '',
                    ...RTDTOT, '', '',
                    '', '', '', '', '', ' ',
                    ' ', ' ','','','','','',
                    ' ']

                let columnIndex = 5;
                weekendValues.forEach(() => {
                    worksheet.mergeCells(`${getExcelColumnName(columnIndex)}1:${getExcelColumnName(columnIndex + 2)}1`);
                    columnIndex += 4;
                });

                worksheet.mergeCells('A1:A2');
                worksheet.mergeCells('B1:B2');
                worksheet.mergeCells('C1:C2');
                worksheet.mergeCells('D1:D2');
                const otherHoursColumnIndex = columnIndex;
                const lastColumnIndex = worksheet.getRow(1).cellCount;
                for (let i = otherHoursColumnIndex; i <= lastColumnIndex; i++) {
                    const columnLetter = getExcelColumnName(i); // Get Excel column name
                    worksheet.mergeCells(`${columnLetter}1:${columnLetter}2`); // Merge row 1 and row 2
                }
                for (i = 0; i < loopedList.length; i++) {
                    worksheet.addRow(loopedList[i]);
                }
                workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'invoice.xlsx');
                    });

                return "downloaded"
            }
            else if (value === 'two') {
                console.log("Selectedyear",selectedMonthYear);
                console.log("selectedValidatedRows",selectedValidatedRows);
                const resp = await downloadVIJAX(selectedMonthYear,selectedValidatedRows,clearSelectedRows);
                if (resp !== null) {
                    let sampleList = resp;
                    let loopedList = [];
                    loopedList.length = 0;
                    let len = sampleList.length;
                    const sample1 = new Date();
                    var newD1 = parseInt(sample1.getMonth() + 1) + '/' + parseInt(sample1.getDate()) + '/' + parseInt(sample1.getFullYear());
                    let i;
                    loopedList.push(['Journal Name', 'Posting Date', 'Vendor Code', 'Text', 'Business Unit', 'Department', 'Value Stream', 'Location',
                        'Customer', 'Project', 'Worker', 'CostCenter', 'Price(Pay Rate)', 'Quantity(Worked Hours)', 'Currency',
                        'LedgerCode', 'Method of Payment', 'Invoice Number', 'Document Date', 'Due Date',])
                    for (i = 0; i < len; i++) {
                        loopedList.push([
                            sanitizeCellValue(sampleList[i].Journal_Name),
                            newD1,
                            sanitizeCellValue(sampleList[i].Vendor_Code),
                            sanitizeCellValue(sampleList[i].Text),
                            sanitizeCellValue(sampleList[i].Business_Unit),
                            sanitizeCellValue(sampleList[i].Departmemt),
                            sanitizeCellValue(sampleList[i].Value_Stream),
                            sanitizeCellValue(sampleList[i].Location),
                            sanitizeCellValue(sampleList[i].Customer),
                            sanitizeCellValue(sampleList[i].Project),
                            sanitizeCellValue(sampleList[i].Worker),
                            sanitizeCellValue(sampleList[i].Cost_Center),
                            sanitizeCellValue(sampleList[i].Pay_Rate),
                            sanitizeCellValue(sampleList[i].Worked_Hours),
                            sanitizeCellValue(sampleList[i].Currency),
                            sanitizeCellValue(sampleList[i].Ledger_Code),
                            sanitizeCellValue(sampleList[i].Methodof_Payment),
                            sanitizeCellValue(sampleList[i].Invoice_Number),
                            sanitizeCellValue(sampleList[i].Document_Date),
                            sanitizeCellValue(sampleList[i].Due_Date),

                        ])
                    }
                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('Sheet1');
                    for (i = 0; i < loopedList.length; i++) {
                        worksheet.addRow(loopedList[i]);
                    }
                    workbook.xlsx.writeBuffer()
                        .then(buffer => {
                            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            FileSaver.saveAs(blob, 'VIJ AX Template.xlsx');
                        });
                    return "downloaded"
                }
                else {
                    // ErrorMessage("Unable to download, try again later");
                    return null;
                }

            }
            else if (value === 'three') {
                const response = await downloadAccruals();
                if (response !== null) {
                    let sampleList = response;
                    let loopedList = [];
                    loopedList.length = 0;
                    let len = sampleList.length;
                    const sample1 = new Date();
                    const currentYear = sample1.getFullYear();
                    const currentMonth = sample1.getMonth();
                    const lastDateOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0); // Moving to next month and subtracting 1 day
                    var newD1 = parseInt(lastDateOfCurrentMonth.getMonth() + 1) + '/' + parseInt(lastDateOfCurrentMonth.getDate()) + '/' + parseInt(lastDateOfCurrentMonth.getFullYear());
                    const firstDateOfNextMonth = new Date(currentYear, currentMonth + 1, 1);
                    var newD2 = parseInt(firstDateOfNextMonth.getMonth() + 1) + '/' + parseInt(firstDateOfNextMonth.getDate()) + '/' + parseInt(firstDateOfNextMonth.getFullYear());
                    let i;
                    loopedList.push(['Journal Name', 'Posting Date', 'Account Code', 'Text', 'Business Unit', 'Department', 'Value Stream', 'Location',
                        'Customer', 'Project', 'Worker', 'CostCenter', 'Amount', 'Currency', 'OffsetAccount'])
                    for (i = 0; i < len; i++) {
                        loopedList.push([
                            sanitizeCellValue(sampleList[i].Journal_Name),
                            newD1,
                            sanitizeCellValue(sampleList[i].Account_Code),
                            sanitizeCellValue(sampleList[i].Text),
                            sanitizeCellValue(sampleList[i].Business_Unit),
                            sanitizeCellValue(sampleList[i].Departmemt),
                            sanitizeCellValue(sampleList[i].Value_Stream),
                            sanitizeCellValue(sampleList[i].Location),
                            sanitizeCellValue(sampleList[i].Customer),
                            sanitizeCellValue(sampleList[i].Project),
                            sanitizeCellValue(sampleList[i].Worker),
                            sanitizeCellValue(sampleList[i].Cost_Center),
                            sanitizeCellValue(sampleList[i].Amount),
                            sanitizeCellValue(sampleList[i].Currency),
                            sanitizeCellValue(sampleList[i].Offset_Account),
                        ])
                        loopedList.push([
                            sanitizeCellValue(sampleList[i].Journal_Name),
                            newD2,
                            sanitizeCellValue(sampleList[i].Account_Code),
                            sanitizeCellValue(sampleList[i].Text),
                            sanitizeCellValue(sampleList[i].Business_Unit),
                            sanitizeCellValue(sampleList[i].Departmemt),
                            sanitizeCellValue(sampleList[i].Value_Stream),
                            sanitizeCellValue(sampleList[i].Location),
                            sanitizeCellValue(sampleList[i].Customer),
                            sanitizeCellValue(sampleList[i].Project),
                            sanitizeCellValue(sampleList[i].Worker),
                            sanitizeCellValue(sampleList[i].Cost_Center),
                            "-" + sanitizeCellValue(sampleList[i].Amount),
                            sanitizeCellValue(sampleList[i].Currency),
                            sanitizeCellValue(sampleList[i].Offset_Account),
                        ])
                    }
                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('Sheet1');
                    for (i = 0; i < loopedList.length; i++) {
                        worksheet.addRow(loopedList[i]);
                    }
                    workbook.xlsx.writeBuffer()
                    .then(buffer => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        FileSaver.saveAs(blob, 'Accruals Template.xlsx');
                    });
                    return "downloaded"
                }
                else {
                    // ErrorMessage("Unable to download, try again later");
                    return null;
                }
            }
            else if (value === 'four') {
                console.log("Selected year", selectedMonthYear);
                console.log("selectedValidatedRows", selectedValidatedRows);
                const resp = await downloadOTPOTemplate(selectedMonthYear, selectedValidatedRows, clearSelectedRows);
            
                if (resp !== null) {
                    const sampleList = resp;
                    const outputList = [];
            
                    // Header
                    outputList.push([
                        'Purchase Order No', 'ItemId', 'Qty', 'Price',
                        'Business Unit', 'Department', 'Value Stream', 'Location',
                        'Customer', 'Project', 'Worker ID', 'CostCenter', 'Text'
                    ]);
            
                    for (const row of sampleList) {
                        // RT Row
                        outputList.push([
                            sanitizeCellValue(row.Purchase_Order_No),
                            sanitizeCellValue(row.ItemId),
                            sanitizeCellValue(row.RTHours),
                            sanitizeCellValue(row.RTPayrate),
                            sanitizeCellValue(row.BusinessUnit),
                            sanitizeCellValue(row.Department),
                            sanitizeCellValue(row.ValueStream),
                            sanitizeCellValue(row.Location),
                            sanitizeCellValue(row.Customer),
                            sanitizeCellValue(row.Project),
                            sanitizeCellValue(row.Worker_ID),
                            sanitizeCellValue(row.CostCenter),
                            sanitizeCellValue(row.RT_Text)
                        ]);
            
                        // OT Row
                        outputList.push([
                            sanitizeCellValue(row.Purchase_Order_No),
                            sanitizeCellValue(row.ItemId),
                            sanitizeCellValue(row.OTHours),
                            sanitizeCellValue(row.OTPayrate),
                            sanitizeCellValue(row.BusinessUnit),
                            sanitizeCellValue(row.Department),
                            sanitizeCellValue(row.ValueStream),
                            sanitizeCellValue(row.Location),
                            sanitizeCellValue(row.Customer),
                            sanitizeCellValue(row.Project),
                            sanitizeCellValue(row.Worker_ID),
                            sanitizeCellValue(row.CostCenter),
                            sanitizeCellValue(row.OT_Text)
                        ]);
                    }
            
                    // Generate Excel
                    const workbook = new ExcelJS.Workbook();
                    const worksheet = workbook.addWorksheet('OT_RT_Template');
                    outputList.forEach(row => worksheet.addRow(row));
            
                    workbook.xlsx.writeBuffer().then(buffer => {
                        const blob = new Blob([buffer], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        FileSaver.saveAs(blob, 'OT-PO Template.xlsx');
                    });
            
                    return "downloaded";
                } else {
                    return null;
                }
            }
            
        }
        else { return null }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const updateAccountingCubeRow = async (props) => {
    try {
        let data = props;
        let url = `${BaseUrl}_1099_Contract_Accounting/UpdateAccountsCubeData`
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const updateMFRow = async (props) => {
    try {
        let data = props;
        let url = `${BaseUrl}_1099_Contract_Accounting/UpdatePayrollHrsData`
        // let url = `https://localhost:7018/api/_1099_Contract_Accounting/UpdatePayrollHrsData`
        const response = await axios.put(url, data, JsonConfig)
        return response
    }
    catch (err) {
        ErrorMessage("Cannot able to update");
        return null;
    }
}
export const ValidateRecord = async (props) => {
    try {
        console.log("Original record:", props);

        let data = Array.isArray(props) ? props : [props];

        // Convert Weekend and WeekStartDate to "yyyy-MM-dd" format
        data = data.map((record) => {
            return {
                ...record,
                Weekend: record.Weekend ? formatDate(record.Weekend) : null,
                WeekStartDate: record.WeekStartDate ? formatDate(record.WeekStartDate) : null,
                WorkTimeEntry_date:record.WorkTimeEntry_date?formatDate(record.WorkTimeEntry_date):null,
                DownloadDate:record.DownloadDate?formatDate(record.DownloadDate):null,
            };
        });

        console.log("Formatted Payload Sent:", JSON.stringify(data, null, 2));

        let url = `${BaseUrl}_1099_Contract_Accounting/ValidateRecord`;
        console.log("Base url:", url);

        const response = await axios.put(url, data, JsonConfig);
        console.log("API Response in validation:", response);
        return response;
    } catch (err) {
        console.error(" API Request Failed:", err);

        if (err.response) {
            console.error(" Response Status Code:", err.response.status);
            console.error(" Response Data:", err.response.data);
            console.error("Validation Errors:", err.response?.data?.errors);
        } else {
            console.error(" No response received. Network issue?");
        }

        ErrorMessage("Cannot update record. Check console for details.");
        return null;
    }
};

// Helper function to format dates
const formatDate = (dateString) => {
    if (!dateString) return "";

    // If already in YYYY-MM-DD format, return as is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
    }

    // Handle both MM-DD-YYYY and MM/DD/YYYY formats
    const dateParts = dateString.includes("/") ? dateString.split("/") : dateString.split("-");

    if (dateParts.length === 3) {
        return `${dateParts[2]}-${dateParts[0].padStart(2, "0")}-${dateParts[1].padStart(2, "0")}`;
    }

    return dateString; // Return original if format is unrecognized
};


